/* istanbul ignore file */
import React from 'react';
import SingleAccountBreadcrumbs from 'domain/sales/account/shared/SingleAccountBreadcrumbs';
import { BreadcrumbItem } from 'framework/ui/BreadCrumbs';

const AccountRelatedContactsBreadcrumbs = () => {
  return (
    <SingleAccountBreadcrumbs>
      <BreadcrumbItem>Related Contacts</BreadcrumbItem>
    </SingleAccountBreadcrumbs>
  );
};

export default AccountRelatedContactsBreadcrumbs;
